// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CustomiserRow{padding-top:1rem;padding-bottom:1.5rem;}@media (max-width: 799px){.CustomiserRow{min-height:170px}}.CustomiserRow:last-of-type{padding-bottom:0}.CustomiserRow__heading{display:-webkit-box;display:-ms-flexbox;display:flex;align-items:center;height:2rem;margin-bottom:0.75rem}.CustomiserRow__part-name{padding:0 1rem 0 4px}.CustomiserRow__heading-slot{margin-left:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
